(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('OrderBagCustom', OrderBagCustom);

    OrderBagCustom.$inject = ['$resource', 'ENV'];

    function OrderBagCustom($resource, ENV) {


        var approveOrderBag = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/approve-order-bag';
            return $resource(resourceUrl, {}, {}
            );
        };
        var approveReserve = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/approve-reserve';
            return $resource(resourceUrl, {}, {}
            );
        };


        var getOrderBagWithEntities = function (OrderBagId) {
            var resourceUrl = ENV.API_BASE_URL + 'api/order-bags-with-entities/' + OrderBagId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var cancelOrderBag = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/cancel-order-bag';
            return $resource(resourceUrl, {}, {}
            );
        };
        var cancelReserve = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/cancel-reserve';
            return $resource(resourceUrl, {}, {}
            );
        };

        var checkin = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/checkin-order-bag';
            return $resource(resourceUrl, {}, {}
            );
        };

        var notCheckin = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/not-checkin-order-bag';
            return $resource(resourceUrl, {}, {}
            );
        };


        var canEditOrderBag = function (OrderBagId) {
            var resourceUrl = ENV.API_BASE_URL + 'api/can-edit-order-bag?id=' + OrderBagId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var removeCheckin = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/remove-checkin-order-bag';
            return $resource(resourceUrl, {}, {}
            );
        };

        var confirmReserveRequestByOrderBagId = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/confirm-reserve-request-by-order-bag-id';
            return $resource(resourceUrl, {}, {}
            );
        };


        var computeFinalPrice = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/client/compute-orderbag-final-price';
            return $resource(resourceUrl, {}, {}
            );
        };
        var saveReserve = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/save-reserve';
            return $resource(resourceUrl, {}, {}
            );
        }
        var updateIntakeFormData = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/update-intake-form-data';
            return $resource(resourceUrl, {}, {}
            );

        }
        var getDefaultIntakeFormData = function (serviceid) {
            if (serviceid)
                var resourceUrl = ENV.API_BASE_URL + 'api/get-default-intakeformData-by-service/' + serviceid;
            return $resource(resourceUrl, {}, {}
            );
            return null;

        }

        var computeFinalPriceFixed = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/compute-orderbag-final-price-fixed';
            return $resource(resourceUrl, {}, {}
            );
        };

        var deleteOrderBagItem = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/delete-order-bag-service-item';
            return $resource(resourceUrl, {}, {}
            );
        };

        var reConfirmReserveRequestByOrderBagId = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/re-confirm-reserve-request-by-order-bag-id';
            return $resource(resourceUrl, {}, {}
            );
        };

        var reSendNotificationByOrderBagId = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/re-send-notification-by-order-bag-id';
            return $resource(resourceUrl, {}, {}
            );
        };

        var deleteReserve = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/delete-reserve';
            return $resource(resourceUrl, {}, {}
            );
        };

        var logIntoServer = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/client/log-from-client';
            return $resource(resourceUrl, {}, {}
            );
        };

        var issueInvoiceInfoByOrderBagId = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/issue-invoice-info-by-order-bag-id';
            return $resource(resourceUrl, {}, {}
            );
        };

        return {
            saveReserve: saveReserve,
            approveOrderBag: approveOrderBag,
            getOrderBagWithEntities: getOrderBagWithEntities,
            cancelOrderBag: cancelOrderBag,
            checkin: checkin,
            notCheckin: notCheckin,
            canEditOrderBag: canEditOrderBag,
            removeCheckin: removeCheckin,
            confirmReserveRequestByOrderBagId: confirmReserveRequestByOrderBagId,
            computeFinalPrice: computeFinalPrice,
            approveReserve: approveReserve,
            cancelReserve: cancelReserve,
            updateIntakeFormData: updateIntakeFormData,
            getDefaultIntakeFormData: getDefaultIntakeFormData,
            computeFinalPriceFixed: computeFinalPriceFixed,
            deleteOrderBagItem: deleteOrderBagItem,
            reConfirmReserveRequestByOrderBagId: reConfirmReserveRequestByOrderBagId,
            reSendNotificationByOrderBagId: reSendNotificationByOrderBagId,
            deleteReserve: deleteReserve,
            logIntoServer: logIntoServer,
            issueInvoiceInfoByOrderBagId: issueInvoiceInfoByOrderBagId

        };
    }
})();
